export default "__VITE_ASSET__37839558__"